import LoadingIndicator from '@gameday/react-components/components/LoadingIndicator'
import { useEffect } from 'react'

import commonStyles from 'shared/styles/common-styles.scss'

const PaymentSuccessPage = () => {
  useEffect(() => {
    window.close()
  }, [])
  return (
    <div className={commonStyles.splashPageContainer}>
      <div className={commonStyles.contentContainer}>
        <LoadingIndicator />
        <h2>Processing</h2>
      </div>
    </div>
  )
}

export default PaymentSuccessPage
